<template>
  <div class="flex justify-center items-center w-screen h-screen container-card">
    <div :class="[
      'card-flip w-full sm:w-2/5',
      { 'flipped': isFlipped }
    ]">
      <div class="card-front">
        <LoginComponent @flipCard="goRegister" />
      </div>
      <div class="card-back">
        <RegisterComponent @flipCard="goLogin" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import LoginComponent from '@/components/login-register/LoginComponent.vue'
import RegisterComponent from '@/components/login-register/RegisterComponent.vue'

const router = useRouter()
const route = useRoute()
const isFlipped = ref(false)

function syncFromQuery() {
  isFlipped.value = route.query.view === 'register'
}
syncFromQuery()

watch(() => route.query.view, () => {
  syncFromQuery()
})

function goRegister() {
  isFlipped.value = true
  router.replace({ query: { view: 'register' } })
}

function goLogin() {
  isFlipped.value = false
  router.replace({ query: { view: 'login' } })
}
</script>

<style>
.container-card {
  perspective: 45em;
}

.card-flip {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  -webkit-font-smoothing: antialiased;
  /* Pour les navigateurs basés sur WebKit */
  -moz-osx-font-smoothing: grayscale;
  /* Pour Firefox sur macOS */
}

.flipped {
  transform: rotateY(180deg)
}

.card-front,
.card-back {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
}

.card-back {
  position: relative;
  transform: rotateY(180deg);
}
</style>